module.exports = (window.Map.Map = window.Map);